import React, { useState } from 'react'
import GhostButton from '../../Buttons/GhostButton'
import { ReactComponent as PlusIcon } from '../../../images/icons/plus.svg'
import { ReactComponent as LinkIcon } from '../../../images/icons/connect_link_icon.svg'
import { useFormContext } from 'react-hook-form'
import { Vendor } from '../../../lib/types/Vendor'
import { getImageURL } from '../../../lib/utils/getImageURL'
import { useModal } from '../../useModal'
import { Button } from '@demandlocal/components'

type Props = {
  vendor: Vendor
  disabled?: boolean
}

export const VinSolutionsInstructions = (): JSX.Element => {
  const { closeModal } = useModal()
  const [step, setStep] = useState<number>(1)
  return (
    <div className={'flex flex-1 flex-col px-12 pt-12 font-Spartan h-full overflow-auto'}>
      <div className={'flex flex-1 flex-col overflow-auto gap-4'}>
        <div className={'font-bold text-blue-primary pl-12 text-3xl'}>
          Connecting to VinSolutions
        </div>
        <div className={'flex pl-12'}>
          <span className="pr-2">{step}: </span>
          {step === 1 && (
            <span>
              As a dealership CRM administrator*, go to "Partner Enablement Page" at{' '}
              <b>
                Settings {'>'} Dealer Settings {'>'} Partner Enablement
              </b>
            </span>
          )}
          {step === 2 && (
            <span>
              Under <b>Application Service Providers</b>, locate <b>Guide by Link One</b>{' '}
              and toggle the integration <b>ON</b>
            </span>
          )}
          {step === 3 && (
            <span>
              Accept the terms in the Confirmation dialogue box (to{' '}
              <em>
                <b>disable</b>
              </em>{' '}
              the integration, toggle it OFF using the same process)
            </span>
          )}
          {step === 4 && (
            <span>
              Congrats! You have completed the setup process. A representative at LinkOne
              will complete a few steps on our end and help you finalize the connection.
            </span>
          )}
        </div>
        {step <= 3 && (
          <div className={'flex pl-12'}>
            <img
              src={getImageURL('images/customers_upload/vinsolutions_instructions_0.png')}
            />
          </div>
        )}
      </div>
      <div
        className={'h-20 items-center flex w-full justify-between border-t-2 py-4 mt-4'}>
        <Button
          variant={'secondary'}
          onClick={(e) => {
            e.preventDefault()
            step > 1 ? setStep(step - 1) : closeModal()
          }}>
          {step > 1 ? 'Back' : 'Close'}
        </Button>
        <Button
          type={'submit'}
          onClick={(e) => {
            e.preventDefault()
            if (step < 4) setStep((prev) => prev + 1)
            if (step === 4) closeModal()
          }}>
          {step < 3 ? 'Next' : 'Done'}
        </Button>
      </div>
    </div>
  )
}

const ConnectedSourceVinSolutions = ({ vendor, disabled }: Props): JSX.Element => {
  const { setValue } = useFormContext()
  const { handleModal } = useModal()

  return (
    <div key={vendor.id} className={'flex items-center justify-between'}>
      <div className={'flex items-center gap-3 flex-1'}>
        <div className={'flex items-center justify-center'}>
          <div className={'w-8 h-8 rounded-full flex'}>
            <img
              src={getImageURL(`images/vendors/${vendor.logo}`)}
              className={'object-contain'}
            />
          </div>
        </div>
        <span
          className={`font-bold text-base text-blue-primary flex-1 ${
            !vendor.connected || disabled ? 'opacity-50' : ''
          }`}>
          {vendor.name}
        </span>

        {!disabled && (
          <GhostButton
            onClick={(e) => {
              e.preventDefault()
              setValue?.(`vendor_${vendor.id}`, [{}])
            }}>
            {vendor.connected ? (
              <PlusIcon className={'w-4 h-6 stroke-primary-persian-blue '} />
            ) : (
              <LinkIcon
                stroke={'#0932C2'}
                fill={'#0932C2'}
                className={'w-4 h-6'}
                onClick={() => handleModal(<VinSolutionsInstructions />)}
              />
            )}
          </GhostButton>
        )}
      </div>
    </div>
  )
}

export default ConnectedSourceVinSolutions
